import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { signOut } from 'aws-auth-lib';
import Loader from '../component/Loader';
import { useRole } from '../utils/RoleContext';
import { useClinic } from '../utils/ClinicContext';
import { useUser } from '../hooks/useUser';
import { resetUser } from '../store/userReducer';
import Logger from '../utils/logger';

function SignOutRedirect() {
    const started = useRef(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { user } = useUser();
    const { setRole } = useRole();
    const { setClinic } = useClinic();

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        const userUuid = user.uuid;

        const endSession = async () => {
            try {
                await signOut();
            } catch (error) {
                Logger.debug('error ending invalid authentication session', error);
            } finally {
                dispatch(resetUser());
                setRole(null);
                setClinic(null);
                sessionStorage.removeItem('role');
                sessionStorage.removeItem('clinic');
                sessionStorage.removeItem('token');
                if (userUuid) {
                    localStorage.removeItem(userUuid);
                    localStorage.removeItem(`${userUuid}-clinic`);
                }
                queryClient.clear();
                navigate('/login', { replace: true });
            }
        };

        void endSession();
    }, [dispatch, navigate, queryClient, setClinic, setRole, user.uuid]);

    return <Loader />;
}

export default SignOutRedirect;
